export default __webpack_public_path__ + "static/media/MRI.5be44e93.png";